import type { ResumeData } from "@reactive-resume/schema";

import { axios } from "@/client/libs/axios";

export const parsePdfResume = async (file: File): Promise<ResumeData> => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await axios.post<ResumeData>("/parser/pdf", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};
